export function safeParseNumber(value) {
  return parseFloat(value.toFixed(12));
}
